<template>
  <div class="list-item with-icon mt-2">
    <v-list-item-avatar min-width="60px" height="60px">
      <v-img height="15px" contain src="@/assets/svg/pool_icon.svg" />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description">
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold">{{ talentPool.name }}</span>
          </div>
          <div class="d-flex mt-1">
            <p class="mb-0">{{ peopleCount }}</p>
            <v-img
              src="@/assets/svg/user-icon.svg"
              max-width="30px"
              height="18"
              contain
            />
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { size } from "lodash";

export default {
  props: {
    talentPool: {
      type: Object,
      required: true
    }
  },
  computed: {
    peopleCount() {
      return size(this.talentPool.users);
    }
  }
};
</script>

<style lang="scss"></style>
